import ReportingOrderList from "./list";


if (document.body.getAttribute("data-current-path") === "reporting/order") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ReportingOrderList();
    }
}